const Square = props => (
  <svg {...props} width="15px" height="15px" viewBox="0 0 15 15">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-653.000000, -96.000000)">
      <rect id="Rectangle-6-Copy" stroke="#313F4C" strokeWidth="1.5" x="653.75" y="96.75" width="13.5" height="13.5"></rect>
    </g>
  </svg>
);

export default Square;
